export default __webpack_public_path__ + "static/media/icon_mute_on.155bc3ad.svg";